import useApiClient from '../../../../hooks/api/useApiClient';
import {
  useDeleteSmartPricingRuleImageMutation,
  useGenerateSmartPricingRuleImageMutation,
  useGetSmartPricingRuleQuery,
  useUploadSmartPricingRuleImageMutation,
} from '../../../../store/api-slices';

export const useGetSmartPricingRule = (id, options) => {
  const { SmartPricingRulesManager } = useApiClient();

  return useGetSmartPricingRuleQuery({ apiManager: SmartPricingRulesManager, id }, { skip: !id, ...options });
};

export const useUploadSmartPricingRuleImage = () => {
  const { SmartPricingRulesManager } = useApiClient();
  const [mutation, ...rest] = useUploadSmartPricingRuleImageMutation();
  const enrichedMutation = (id, data) => mutation({ apiManager: SmartPricingRulesManager, id, data });

  return [enrichedMutation, ...rest];
};

export const useDeleteSmartPricingRuleImage = () => {
  const { SmartPricingRulesManager } = useApiClient();
  const [mutation, ...rest] = useDeleteSmartPricingRuleImageMutation();
  const enrichedMutation = (id, data) => mutation({ apiManager: SmartPricingRulesManager, id, data });

  return [enrichedMutation, ...rest];
};

export const useGenerateSmartPricingRuleImage = () => {
  const { SmartPricingRulesManager } = useApiClient();
  const [mutation, ...rest] = useGenerateSmartPricingRuleImageMutation();
  const enrichedMutation = (id) => mutation({ apiManager: SmartPricingRulesManager, id });

  return [enrichedMutation, ...rest];
};
